import { MediaMatcher } from '@angular/cdk/layout';
import { Component, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { cantoConfig } from 'src/app/config/canto.config';
import { LanguageService } from 'src/app/service/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  language = 'en';
  subscription = new Subscription();
  isLoading = true;

  constructor(
    private mediaMatcher: MediaMatcher,
    private languageService: LanguageService
  ) {
    const language = this.languageService.currentLanguage
      .pipe()
      .subscribe((lang) => {
        this.language = lang;
      });
    this.subscription.add(language);
  }

  private _match = '(max-width: 768px) and (min-width: 1px)';

  get isMobile(): boolean {
    return this.mediaMatcher.matchMedia(this._match).matches;
  }

  get image() {
    const device = this.isMobile ? 'mobile' : 'desktop';
    return cantoConfig[this.language][device];
  }

  onLanguageChange(language: string) {
    this.languageService.setLanguage(language);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: any) {
    event.preventDefault();
  }

  onImageLoaded() {
    this.isLoading = false;
  }
}
